/**
 * Пауза перед результатом (шарик бежит, барабаны крутятся, слой стирается):
 * 1,5–2 с, пропускается кнопкой и не играется вовсе при «меньше движения»
 * (DESIGN-SYSTEM.md). Исход считает каркас уже после паузы — сама пауза
 * ничего не решает и не трогает Rng.
 */
import { useEffect, useRef, useState } from 'preact/hooks';
import { prefersReducedMotion } from '../lib/motion';

export interface Reveal {
  /** Пауза идёт. */
  running: boolean;
  /** Запустить паузу и по её концу вызвать `done`; при «меньше движения» — сразу. */
  begin(done: () => void): void;
  /** Пропустить паузу: `done` вызывается немедленно. */
  skip(): void;
}

export function useReveal(ms: number): Reveal {
  const [running, setRunning] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const pending = useRef<(() => void) | null>(null);

  const fire = () => {
    const done = pending.current;
    pending.current = null;
    if (timer.current !== null) clearTimeout(timer.current);
    timer.current = null;
    setRunning(false);
    done?.();
  };

  useEffect(
    () => () => {
      if (timer.current !== null) clearTimeout(timer.current);
    },
    [],
  );

  return {
    running,
    begin(done) {
      if (pending.current !== null) return;
      pending.current = done;
      if (ms <= 0 || prefersReducedMotion()) {
        fire();
        return;
      }
      setRunning(true);
      timer.current = setTimeout(fire, ms);
    },
    skip: fire,
  };
}
